<template>
    <div id="event-selection">
        <div class="modal fade in" style="display: block;">
            <div class="modal-dialog" role="document" v-if="teamNameFromUrl && error">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">{{event.title}}</h4>
                        <small v-if="game.comments && game.comments.intro">{{game.comments.intro}}</small>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-danger mb-0" role="alert">
                            <strong>{{ $t('common.error') }}</strong> {{ $t('errors.' + error) }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-dialog" role="document" v-if="!teamNameFromUrl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">{{event.title}}</h4>
                        <small v-if="game.comments && game.comments.intro">{{game.comments.intro}}</small>
                    </div>
                    <form @submit.prevent="enter()" v-if="!teamNameFromUrl">
                        <div class="modal-body">
                            <div class="form-group">
                                <label>{{ $t('team_selection.enter_team_name') }}</label>
                                <div class="input-group">
                                    <input class="form-control" type="text"
                                        :placeholder="$t('team_selection.team_name')" v-model="teamName">
                                    <span class="input-group-btn">
                                        <button type="submit" class="btn btn-primary" :disabled="loading">
                                            <i class="fa"
                                               :class="{'fa-refresh fa-fast-spin': loading, 'fa-sign-in': !loading}"
                                               aria-hidden="true"></i> {{ $t('common.enter') }}
                                        </button>
                                    </span>
                                </div>
                            </div>
                            <div class="alert alert-danger" role="alert" v-if="error">
                                <strong>{{ $t('common.error') }}</strong> {{ $t('errors.' + error) }}
                            </div>
                            <hr>
                            <a href @click.prevent="(teamName = recentTeam.name) && resumeRecentTeam()" v-if="recentTeam">
                                <i class="fa fa-repeat"
                                   :class="{'fa-fast-spin': loading && loadingName === recentTeam.name}"
                                   aria-hidden="true"></i>
                                <span v-html="$t('team_selection.continue_as_team', {
                                    team: '<strong>'+recentTeam.name+'</strong>'
                                })"></span>
                            </a>
                            <a href @click.prevent="exit()" class="pull-right text-muted">
                                <i class="fa fa-close" aria-hidden="true"></i> {{ $t('common.cancel') }}
                            </a>
                            <div class="clearfix"></div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal-backdrop fade in"></div>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data () {
            return {
                teamName: '',
                teamNameFromUrl: !!TEAM_NAME_FROM_URL
            };
        },
        computed: mapState({
            event: state => state.events.activeEvent,
            game: state => state.events.activeEvent,
            recentTeam: state => state.events.recentTeam,
            loading: state => state.teams.loading,
            loadingName: state => state.teams.loadingName,
            error: state => state.teams.error
        }),
        methods: {
            ...mapActions([
                'createTeam',
                'resumeRecentTeam'
            ]),
            enter() {
                if (!this.teamName) {
                    return
                }

                if (this.recentTeam && this.teamName === this.recentTeam.name) {
                    this.resumeRecentTeam()
                } else {
                    this.createTeam(this.teamName)
                }
            },
            exit() {
                this.$store.commit('EXIT_GAME');
            }
        },
        mounted() {
            if (this.teamNameFromUrl) {
                const query = window.location.pathname.split('/')
                this.teamName = query[2] || ''
                this.enter()
            }
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// team_selection.vue?3fb79fe6